import { useLazyLoadQuery } from "react-relay"
import { graphql } from "relay-runtime"
import { useChIsPatientInDataGuardQuery as UseChIsPatientInDataGuardQueryType } from "@/modules/patients/information/consent/ch/services/__generated__/useChIsPatientInDataGuardQuery.graphql"

const chIsPatientInDataGuardQuery = graphql`
  query useChIsPatientInDataGuardQuery($patientId: ID!) {
    ch_isPatientInDataGuard(patientId: $patientId)
  }
`

const useChIsPatientInDataGuardQuery = (patientId: string) => {
  const data = useLazyLoadQuery<UseChIsPatientInDataGuardQueryType>(
    chIsPatientInDataGuardQuery,
    { patientId },
    { fetchPolicy: "store-or-network" },
  )

  return data.ch_isPatientInDataGuard
}

export { useChIsPatientInDataGuardQuery }
